import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputTextComponent from '../components/inputs/InputTextComponent';
import SubcontractorService from '../services/SubcontractorService';
import InputTextareaComponent from '../components/inputs/InputTextareaComponent';

class SubcontractorEditDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new SubcontractorService());
        this.state = {
            elementId: props.elementId,
            element: {
                name: '',
                nip: '',
                regon: '',
                note: '',
                status: {enumValue: 'ACTIVE', label: 'Aktywny'},
            },
            viewMode: this.props.viewMode,
        };
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <div className='left-footer-dialog-button-container'></div>
                <ActionButton
                    label={t('details.cancel')}
                    variant={'button cancel-button white'}
                    handleClick={(e) => {
                        this.props.onHide(undefined);
                    }}
                />
                <ActionButton
                    label={this.state.viewMode === 'NEW' ? t('subcontractor.addButton') : t('details.saveChanges')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                    rendered={this.state.viewMode !== 'DELETE'}
                />
            </div>
        );
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12'>
                <DivContainer colClass='col-12'>
                    <label>
                        {this.state.viewMode === 'NEW'
                            ? `${t('subcontractor.addHeader')}`
                            : this.state.viewMode === 'EDIT'
                            ? `${t('subcontractor.editHeader')}`
                            : this.state.viewMode === 'DELETE'
                            ? `${t('subcontractor.deleteHeader')}`
                            : null}
                    </label>
                </DivContainer>
            </DivContainer>
        );
    }
    updateElement(data) {
        this.setState(
            {
                element: data,
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    setElement() {
        if (this.props.element) {
            this.updateElement(this.props.element);
        }
    }
    
    getAddSucces() {
        const {t} = this.props;
        return t('subcontractor.addSuccess');
    }

    getUpdateSucces() {
        const {t} = this.props;
        return t('subcontractor.updateSuccess');
    }
    createOrUpdate() {
        const {element} = this.state;
        this.scrollToTop();
        if (this.props._isMounted) {
            if (element.id === undefined || element.id === null) {
                this.service
                    .add(element)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getAddSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message);
                        this.unblockUi();
                    });
            } else {
                this.service
                    .update(element)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getUpdateSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message);
                        this.unblockUi();
                    });
            }
        }
    }

    renderDetails() {
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <InputTextComponent
                        id='name'
                        name='name'
                        label={'Nazwa'}
                        colClass='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'
                        value={this.state.element.name}
                        validator={this.validator}
                        validators='required|max:255'
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                    />
                    <InputTextComponent
                        id='nip'
                        name='nip'
                        label={'NIP'}
                        colClass='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12'
                        value={this.state.element.nip}
                        validator={this.validator}
                        validators='not_required'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                    />
                    <InputTextComponent
                        id='regon'
                        name='regon'
                        label={'Regon'}
                        colClass='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12'
                        value={this.state.element.regon}
                        validator={this.validator}
                        validators='not_required'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                    />

                    <InputTextareaComponent
                        id='note'
                        name='note'
                        label={'Notatka'}
                        colClass='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'
                        value={this.state.element.note}
                        validator={this.validator}
                        validators='not_required|max:4096'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                        handleClick={null}
                    />
                </DivContainer>
            </React.Fragment>
        );
    }
}

SubcontractorEditDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    visible: false,
    stationId: undefined,
};

SubcontractorEditDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
    stationId: PropTypes.number,
    roleTypes: PropTypes.object,
    className: PropTypes.string,
};

export default withTranslation()(SubcontractorEditDialog);
